<template>
<!-- 贷款意向 -->
  <div class="txzl-wrap">
    <p>*您的信息仅展示给银行或持牌平台，未经您授权我们不会泄露您的信息*</p>
    <div class="txzl-wrap-title">
      <span>贷款意向</span>
      <span @click="$router.go(-1)" v-if="loanNumber!== 1">上一步</span>
    </div>
    <div class="loan-last-wrap">
      <div class="loanprice">
        <h2>您想贷多少</h2>
        <ul>
          <li v-for="(items, index) in loanAmountData" :class="[loan_amount === items.text_value ? 'check' : '']" @click="checkValueAmount(items.text_value)" :key="index">{{items.text}}</li>
        </ul>
        <!-- <van-field
          v-model="form.loan_amount"
          v-if="infoData.result.loan_amount"
          center
          label="其他额度"
          placeholder="请输入1-50的数字"
          type="number"
          format-trigger="onBlur"
          @keyup="otherPrice"
        >
          <template #button>
            <span class="color-333">万元</span>
          </template>
        </van-field> -->
      </div>
      
      <div class="loanprice" v-if="infoData.result.loan_length">
        <h2>您想贷多长时间</h2>
        <ul>
          <li v-for="(items, index) in loanLengthData" @click="checkValueLength(items.text_value)"  :class="[form.loan_length === items.text_value ? 'check' : '']" :key="index">{{items.text}}</li>
        </ul>
      </div>
      <div class="loanprice" v-if="infoData.result.loan_use">
        <h2>您的贷款用途是什么</h2>
        <ul>
          <li v-for="(items, index) in loanUseData" @click="checkValueUse(items.text_value)" :class="[form.loan_use === items.text_value ? 'check' : '']" :key="index">{{items.text}}</li>
        </ul>
      </div>
    </div>

    <div class="btn-fixed" @click="isSubmitLoan">
      <div class="loanbtn">
        <p>马上贷款</p>
      </div>
    </div>
    <van-overlay :show="showOverlay" >
      <div class="loanyx-wrapper" @click.stop>
        <div class="block" >
          <p>您的手机号和申请信息将提交给合作方，我们需要您授权此操作。</p>
          <div class="loan-btn-felx-wrap">
            <van-button type="default" @click="returnIndex" block>取消借款申请</van-button>
            <van-button type="default" @click="goNext" block>授权并提交申请</van-button>
          </div>
        </div>
        <div class="close-icon" @click="closeModal"><van-icon  name="cross" color="#fff"/></div>
      </div>
    </van-overlay>
  </div>
</template>
<script>
import {  Field, Toast, Overlay, Icon, Button } from 'vant'
import { mapState, mapActions } from 'vuex'
export default {
  name: 'Loanyx',
  data() {
    const infoData = JSON.parse(window.localStorage.getItem('infoData'))
    return {
      radio: '1',
      showOverlay: false,
      form: {
        loan_amount: '',
        loan_length: '',
        loan_use: '',
      },
      loan_amount: '',
      showCity: false,
      cascaderValue: '',
      loanAmountData: infoData.result.loan_amount.options,
      loanLengthData: infoData.result.loan_length.options,
      loanUseData: infoData.result.loan_use.options,
      channel_lable: window.localStorage.getItem('channel'),
      loanBtnWidth: 0,
      loanNumber: Number(this.$route.query.loanNumber),
      infoData
    }
  },
  created() {
    const loanPriceData = window.localStorage.getItem('loanPriceData')
    this.loanBtnWidth = ((this.loanNumber-1)/Number(this.infoData.result_total))*100
    if(!!loanPriceData) {
      this.form = Object.assign({}, this.form, JSON.parse(loanPriceData)) 
      // console.log(this.form)
      this.loan_amount = this.form.loan_amount + '万'
    }
  },
  methods: {
    ...mapActions(['commitData']),
    closeModal() {
      this.showOverlay = false
    },
    returnIndex() {
      this.$router.push('/loan?channel_lable=' + this.channel_lable)
    },
    checkValueAmount(value) {
      this.form.loan_amount = parseInt(value)
      this.loan_amount = value
    },
    checkValueLength(value) {
      this.form.loan_length = value
    },
    checkValueUse(value) {
      this.form.loan_use = value
    },
    otherPrice() {
      // console.log(this.form.loan_amount)
      this.loan_amount = this.form.loan_amount + '万'
      this.formatter(Number(this.form.loan_amount))
    },
    formatter(value) {
      // 过滤输入的数字
      if(value > 50){
        this.loan_amount = 50 + '万'
        this.form.loan_amount = 50
        return 50
      } else if(value < 1) {
        this.loan_amount = 1 + '万'
        this.form.loan_amount = 1
        return 1
      }else {
        this.form.loan_amount = value
        return value
      }
    },
    isSubmitLoan() {
      if(!this.form.loan_amount && this.infoData.result.loan_amount) {
        this.$toast('请选择额度')
      }else
      // if(Number(this.form.loan_amount) < 1 && this.infoData.result.loan_amount){
      //   this.$toast('额度不能小于1万')
      // }else
      // if(Number(this.form.loan_amount) > 50 && this.infoData.result.loan_amount){
      //   this.$toast('额度不能大于50万')
      // }else
      if(!this.form.loan_length && this.infoData.result.loan_length) {
        this.$toast('请选择贷款时间')
      }else
      if(!this.form.loan_use && this.infoData.result.loan_use) {
        this.$toast('请选择贷款用途')
      }else {
        this.showOverlay = true
      }
    },
    goNext() {
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
        loadingType: 'spinner',
      });
      const loanPriceData = JSON.stringify(this.form)
      window.localStorage.setItem('loanPriceData', loanPriceData)
      // this.$router.push('/loan/selectxdjl?channel_lable='+ this.channel_lable)
      this.handleLoan(this.form)
    },
    handleLoan(loanPriceData) {
      const token = window.localStorage.getItem('token')
      const channel_lable = this.channel_lable
      const loanParams = JSON.parse(window.localStorage.getItem('loanParams'))
      // const loanPriceData = JSON.parse(window.localStorage.getItem('loanPriceData'))
      const baseInfoData = JSON.parse(window.localStorage.getItem('baseInfoData'))
      const subParam = Object.assign({}, loanParams, loanPriceData, baseInfoData, {channel_lable: channel_lable})
      // subParam.city_name = baseInfoData.provcity
     
      subParam.city_name = baseInfoData.provcity
      if(subParam.welidai_name === '') {
        subParam.welidai_name = '无微粒贷'
      }
      if(channel_lable === 'cdol') {
        subParam.token = token
        subParam.mobile = ''
      }else {
        subParam.mobile = loanParams.phone
      }
      // console.log(subParam)
      this.commitData({
        request: 'webapi/submitloan',
        path: 'webapi/submitloan',
        data: subParam,
        onSuccess: (res) => {
          // alert(JSON.stringify(res))
          // CallbackClickForm();
          this.$router.push('/applysuccess?channel_lable='+channel_lable)
        },
        onFail: (err) => {
          // alert(JSON.stringify(err))
          this.$toast(err.msg)
        }
      });
    },
  },
  components: {
    [Field.name]: Field,
    [Overlay.name]: Overlay,
    [Icon.name]: Icon,
    [Button.name]: Button
  }
}
</script>